import $$ from '@/store/plugins/storage'

const namespace = 'productManage'
$$.setNamespace(namespace)

const state = {
  typeId: 0,
  categaryTypeList: [],
}

const mutations = {
  _typeId(state, value) {
    state.typeId = value
  },
  _categaryTypeList(state, value) {
    state.categaryTypeList = value
  },
}

const actions = {
  _AddType({ commit, state }, value) {
    let typeList = state.categaryTypeList
    typeList.push(value)
    commit('_categaryTypeList', typeList)
  },
  _DesType({ commit, state }, value) {
    let typeList = state.categaryTypeList
    for (var i = 0; i < typeList.length; i++) {
      if (typeList[i].id === value.id) {
        typeList.splice(i, 1)
        if (value.name !== '') {
          typeList.push(value)
        }
      }
    }
    commit('_categaryTypeList', typeList)
  },
}
export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/productManage.js